import { Observer } from "mobx-react";
import { useStores } from "../../store";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import { useEffect, useState } from "react";
import { toJS } from "mobx";
import Completed from "./Completed";
import { useLocation, useNavigate } from "react-router-dom";
import MockTestAnalyticsPopup from "../reusble_components/MockTestAnalyticsPopup";
export default function Question() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const applicationId = queryParams.get("applicationId");
  const navigate = useNavigate();
  const { MockStore } = useStores();
  const [selectedOption, setSelectedOption] = useState(null);
  const branch = localStorage.getItem("branch");
  const [submit, setSubmit] = useState(false);
  useEffect(() => {
    // console.log(
    //   "hello mohan",
    //   Number(MockStore.questionNumber),
    //   MockStore.question[MockStore.section].length - 1,
    //   MockStore.section,
    //   branch,
    //   (Number(MockStore.questionNumber) ===
    //     MockStore.question[MockStore.section].length - 1) &
    //     (MockStore.section === "CORE")
    // );
    if (
      Number(MockStore.questionNumber) ===
        MockStore.question[MockStore.section].length - 1 &&
      MockStore.section === "CORE"
    ) {
      setSubmit(true);
    } else {
      setSubmit(false);
    }
  }, [MockStore.questionNumber]);
  const [noOfAptitudeQuestions, setNoOfAptitudeQuestions] = useState(0);
  const [noOfReasoningQuestions, setNoOfReasoningQuestions] = useState(0);
  const [noOfVerbalQuestions, setNoOfVerbalQuestions] = useState(0);
  const [noOfTechnicalQuestions, setNoOfTechnicalQuestions] = useState(0);
  const [noOfAptitudeQuestionsAnswered, setNoOfAptitudeQuestionsAnswered] =
    useState(0);
  const [noOfReasoningQuestionsAnswered, setNoOfReasoningQuestionsAnswered] =
    useState(0);
  const [noOfVerbalQuestionsAnswered, setNoOfVerbalQuestionsAnswered] =
    useState(0);
  const [noOfTechnicalQuestionsAnswered, setNoOfTechnicalQuestionsAnswered] =
    useState(0);
  const [noOfQuestions, setNoOfQuestions] = useState(0);
  const [noOfUnansweredQuestions, setNoOfUnansweredQuestions] = useState(0);
  const [popup, setPopup] = useState(false);

  const handleCheck = () => {
    let aptitudeQuestions = 0;
    let reasoningQuestions = 0;
    let verbalQuestions = 0;
    let technicalQuestions = 0;
    let aptitudeQuestionsAnswered = 0;
    let reasoningQuestionsAnswered = 0;
    let verbalQuestionsAnswered = 0;
    let technicalQuestionsAnswered = 0;
    let questions = 0;
    let unansweredQuestions = 0;

    MockStore.question.APTITUDE.forEach((item) => {
      questions++;
      aptitudeQuestions++;
      if (item.userAns) {
        aptitudeQuestionsAnswered++;
      } else {
        unansweredQuestions++;
      }
    });

    MockStore.question.REASONING.forEach((item) => {
      questions++;
      reasoningQuestions++;
      if (item.userAns) {
        reasoningQuestionsAnswered++;
      } else {
        unansweredQuestions++;
      }
    });

    MockStore.question.VERBAL.forEach((item) => {
      verbalQuestions++;
      questions++;
      if (item.userAns) {
        verbalQuestionsAnswered++;
      } else {
        unansweredQuestions++;
      }
    });

    MockStore.question.CORE.forEach((item) => {
      technicalQuestions++;
      questions++;
      if (item.userAns) {
        technicalQuestionsAnswered++;
      } else {
        unansweredQuestions++;
      }
    });

    setNoOfAptitudeQuestions(aptitudeQuestions);
    setNoOfReasoningQuestions(reasoningQuestions);
    setNoOfVerbalQuestions(verbalQuestions);
    setNoOfTechnicalQuestions(technicalQuestions);
    setNoOfAptitudeQuestionsAnswered(aptitudeQuestionsAnswered);
    setNoOfReasoningQuestionsAnswered(reasoningQuestionsAnswered);
    setNoOfVerbalQuestionsAnswered(verbalQuestionsAnswered);
    setNoOfTechnicalQuestionsAnswered(technicalQuestionsAnswered);
    setNoOfQuestions(questions);
    setNoOfUnansweredQuestions(unansweredQuestions);
    setPopup(true);
  };

  const Submit = () => {
    // get mocktestId from URL
    const urlParams = new URLSearchParams(window.location.search);
    const mocktestId = urlParams.get("mocktestId");
    MockStore.getAnswer(applicationId ? applicationId : null, mocktestId);
    MockStore.setTestOnLive(false);
    MockStore.setQuestionNumber(1);
    MockStore.setSection("APTITUDE");
    navigate("/mock-answer");
  };

  const handleSubmit = () => {
    // console.log(
    //   "hello hi",
    //   Number(MockStore.questionNumber),
    //   MockStore.question[MockStore.section].length - 1,
    //   MockStore.section,

    //   (Number(MockStore.questionNumber) ===
    //     MockStore.question[MockStore.section].length - 1) &
    //     (MockStore.section === "CORE")
    // );
    if (
      (Number(MockStore.questionNumber) ===
        MockStore.question[MockStore.section].length - 1) &
      (MockStore.section === "CORE")
    ) {
      MockStore.setSubmit(true);
    } else {
      MockStore.setSubmit(false);
    }
  };
  const handleOptionChange = (option) => {
    console.log(option);

    setSelectedOption(option);
  };
  return (
    <Observer>
      {() => {
        return (
          <div className="bg-gray-100 w-full h-[100%] p-5 md:p-14 rounded-3xl">
            {popup && (
              <MockTestAnalyticsPopup
                Apptitude={noOfAptitudeQuestions}
                Reasoning={noOfReasoningQuestions}
                Verbal={noOfVerbalQuestions}
                Tech={noOfTechnicalQuestions}
                ApptitudeAnswered={noOfAptitudeQuestionsAnswered}
                ReasoningAnswered={noOfReasoningQuestionsAnswered}
                VerbalAnswered={noOfVerbalQuestionsAnswered}
                TechAnswered={noOfTechnicalQuestionsAnswered}
                TotalAnswered={noOfQuestions - noOfUnansweredQuestions}
                TotalQuestions={noOfQuestions}
                handleCancel={() => setPopup(false)}
                handleSubmit={Submit}
              />
            )}
            <div className="flex flex-col  pb-4 ">
              <Completed />
              <span className="text-primary font-semibold">
                {MockStore.section}
              </span>{" "}
              <span>Question {MockStore.questionNumber} </span>
              <span>
                {MockStore?.question[MockStore.section][
                  Number(MockStore.questionNumber) - 1
                ]?.question
                  ? MockStore.question[MockStore.section][
                      Number(MockStore.questionNumber) - 1
                    ]?.question
                  : ""}
              </span>
            </div>
            <div className="flex flex-col gap-4 ">
              {/* {MockStore.section === "Aptitude" &&
                MockStore.question[MockStore.section][
                  Number(MockStore.questionNumber) - 1
                ].options.map((option, index) => (
                  <label
                    key={index}
                    className={`flex flex-row items-center justify-between p-4 bg-white rounded-2xl ${
                      selectedOption === option ? "border-primary" : ""
                    }`}
                  >
                    <span>{option}</span>
                    <input
                      type="radio"
                      name="option"
                      className="text-primary"
                      value={option}
                      checked={selectedOption === option}
                      onChange={() => handleOptionChange(option)}
                    />
                  </label>
                ))} */}
              {MockStore?.question[MockStore.section][
                Number(MockStore.questionNumber) - 1
              ]?.options &&
                Object.entries(
                  MockStore?.question[MockStore.section][
                    Number(MockStore.questionNumber) - 1
                  ]?.options
                ).map(([key, value], index) => (
                  <label
                    key={index}
                    className={`flex flex-row items-center justify-between p-4 bg-white rounded-2xl  ${
                      MockStore.question[MockStore.section][
                        Number(MockStore.questionNumber) - 1
                      ].userAns === key
                        ? "border border-primary"
                        : ""
                    }`}
                  >
                    <span>{value}</span>
                    <input
                      type="radio"
                      name="option"
                      className="text-primary"
                      onChange={() => {
                        handleOptionChange(key);
                        MockStore.question[MockStore.section][
                          Number(MockStore.questionNumber) - 1
                        ].userAns = key;
                        MockStore.setAnswer();
                        console.log("answer", MockStore.Answer);
                      }}
                      checked={
                        MockStore.question[MockStore.section][
                          Number(MockStore.questionNumber) - 1
                        ].userAns === key
                      }
                    />
                  </label>
                ))}
            </div>
            <div className="flex justify-between mt-4">
              <button
                className={` ${
                  MockStore.questionNumber === "1" &&
                  MockStore.section.toUpperCase() === "APTITUDE"
                    ? "hidden "
                    : "flex"
                }  flex-row  items-center gap-2 `}
                onClick={() => {
                  handleSubmit();
                  if (MockStore.questionNumber !== "0") {
                    MockStore.setQuestionNumber(
                      String(Number(MockStore.questionNumber) - 1)
                    );
                  }
                  if (MockStore.questionNumber === "0") {
                    if (MockStore.section.toUpperCase() === "REASONING") {
                      MockStore.setSection("APTITUDE");
                      MockStore.setQuestionNumber(MockStore.aptitude?.length);
                    } else if (MockStore.section.toUpperCase() === "VERBAL") {
                      MockStore.setSection("REASONING");
                      MockStore.setQuestionNumber(MockStore.reasonong?.length);
                    } else if (MockStore.section.toUpperCase() === "CORE") {
                      
                      MockStore.setSection("VERBAL");
                      MockStore.setQuestionNumber(MockStore.verbals?.length);
                    }
                  }
                }}
                disabled={MockStore.questionNumber === 1}
              >
                <IoMdArrowRoundBack className="text-primary "></IoMdArrowRoundBack>
                Previous
              </button>
              {MockStore.Submit ? (
                <button
                  className="bg-primary text-white rounded-xl px-4 py-2"
                  onClick={() => {
                    handleCheck();
                  }}
                >
                  <span>Submit</span>
                </button>
              ) : (
                <button
                  className={` ${
                    MockStore.questionNumber === "1" ? "ml-auto  mr-4 " : "flex"
                  }  flex justify-center items-center gap-2 `}
                  onClick={() => {
                    handleSubmit();
                    console.log(toJS(MockStore.question));
                    if (
                      Number(MockStore.questionNumber) !==
                      MockStore.question[MockStore.section].length
                    ) {
                      MockStore.setQuestionNumber(
                        String(Number(MockStore.questionNumber) + 1)
                      );
                    } else {
                      if (MockStore.section.toUpperCase() === "APTITUDE") {
                        MockStore.setSection("REASONING");
                        MockStore.setQuestionNumber("1");
                      } else if (
                        MockStore.section.toUpperCase() === "REASONING"
                      ) {
                        MockStore.setSection("VERBAL");
                        MockStore.setQuestionNumber("1");
                      } else if (MockStore.section.toUpperCase() === "VERBAL") {
                        MockStore.setSection("CORE");
                        MockStore.setQuestionNumber("1");
                      }
                    }
                  }}
                >
                  Next
                  <IoMdArrowRoundForward className="text-primary"></IoMdArrowRoundForward>
                </button>
              )}
            </div>
          </div>
        );
      }}
    </Observer>
  );
}
